import InnerHTML from "./InnerHTML";

const Payment = ({
  checkoutHTML,
  checkoutScript,
  loading,
}: {
  checkoutHTML: string;
  checkoutScript: string;
  loading: boolean;
}) => {
  return (
    <>
      {checkoutHTML ? (
        <>
          <InnerHTML html={checkoutHTML} />
          <InnerHTML html={checkoutScript} />
        </>
      ) : (
        loading
      )}
    </>
  );
};

export default Payment;
